import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import './App.css';
import HowWeWork from './components/HowWeWork';
import Services from './components/Services';
import Projects from './components/Projects';
import Blogs from './components/Blogs';
import Footer from './components/Footer';
import Testimonials from './components/Testimonial';
import WhyChooseUs from './components/WhyChooseUs';
import ContactSection from './components/Contact';
import Test from './components/Test';

const App = () => {
  return (
    <div style={{ background: '#111' }}>
      <Navbar />

      <section id="home">
        <Hero />
      </section>

      <section id="about">
        <About />
      </section>

      <section id="services">
        <Services />
      </section>

      <section id="projects">
        <Projects />
      </section>

      <section id="why-choose-us">
        <WhyChooseUs />
      </section>

      <section id="how-we-work">
        <HowWeWork />
      </section>

      <section id="blog">
        <Blogs />
      </section>

      <section id="testimonials">
        <Testimonials />
      </section>

      <section id="contact">
        <ContactSection />
      </section>

      <section id="test">
        <Test />
      </section>

      <Footer />
    </div>
  );
};

export default App;